import { number_format } from '@/api/filter';
export const config = {
    data() {
        return {
            columns: [],
            searchParams: {
                orderType:'1',
                dateType: '1'
            }
        };
    },
    methods: {
        getColumns() {
            let statusMap = {
                '-1': '退保',
                '0': '终止',
                '1': '保障中'
            };
            this.columns = [
                {
                    title: '承保时间',
                    key: 'issueTime',
                    minWidth: 160,
                    align: 'center',
                    render(h, params) {
                        let issueTime = params.row.issueTime && params.row.issueTime.substring(0, 16);
                        return <span>{issueTime}</span>;
                    }
                },
                {
                    title: '保单号/订单号',
                    key: 'orderNo',
                    minWidth: 180,
                    align: 'center',
                    render(h, params) {
                        return (
                            <div>
                                <p>{params.row.policyNo}</p>
                                <p>{params.row.orderNo}</p>
                            </div>
                        );
                    }
                },
                {
                    title: '产品名称',
                    key: 'productName',
                    minWidth: 230,
                    align: 'center'
                },
                {
                    title: '投保人',
                    key: 'holderName',
                    minWidth: 180,
                    align: 'center'
                },
                {
                    title: '保险期间',
                    key: 'startTime',
                    minWidth: 180,
                    align: 'center',
                    render(h, params) {
                        let startTime = params.row.startTime.substring(0, 10);
                        let endTime = params.row.endTime.substring(0, 10);
                        return (
                            <span>
                                {startTime || '-'} 至 {endTime || '-'}
                            </span>
                        );
                    }
                },
                {
                    title: '出单保费（元）',
                    key: 'fee',
                    minWidth: 140,
                    align: 'center',
                    render(h, params) {
                        return <span> {number_format(params.row.fee, 2)}</span>;
                    }
                },
                {
                    title: '出单服务费（元）',
                    key: 'commission',
                    minWidth: 140,
                    align: 'center',
                    render(h, params) {
                        return <span> {number_format(params.row.commission, 2)}</span>;
                    }
                },
                {
                    title: '保单状态',
                    key: 'status',
                    minWidth: 140,
                    align: 'center',
                    render(h, params) {
                        return <span> {statusMap[params.row.status]}</span>;
                    }
                },
                {
                    title: '出单业务员',
                    key: 'salemanName',
                    minWidth: 180,
                    align: 'center',
                    render(h, params) {
                      return <span>{params.row.staffNo} /{params.row.salemanName}</span>;
                    }
                },
                {
                    title: '所属团队',
                    key: 'groupName',
                    minWidth: 200,
                    align: 'center',
                    render(h, params) {
                      return <span>{params.row.organizationName} /{params.row.groupName}</span>;
                    }
                },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center',
                    width: '180',
                    fixed: 'right'
                }
            ];
        }
    }
};
